import { useRequiredContext } from "@redotech/react-util/context";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { OrderManagementPermissions } from "@redotech/redo-model/permissions";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import BarChart10FilledIcon from "@redotech/redo-web/icon-old/bar-chart-10-filled.svg";
import BarChart10Icon from "@redotech/redo-web/icon-old/bar-chart-10.svg";
import { memo } from "react";
import { useMatch } from "react-router-dom";

const ANALYTICS_TEAM_IDS = [
  "6695909334acb556dcba6002",
  "663110249f2d0d0007016df3",
];

const LOCAL_STORAGE_KEY = "redo.showOrderFulfillmentAnalytics";

function isAnalyticsEnabledViaLocalStorage(): boolean {
  try {
    return localStorage.getItem(LOCAL_STORAGE_KEY) === "true";
  } catch {
    return false;
  }
}

export const AnalyticsItem = memo(function AnalyticsItem() {
  const routes = useRequiredContext(MerchantRoutesContext);
  const team = useRequiredContext(TeamContext);
  const urlPrefix = routes.analyticsOrderFulfillmentHref;
  const anyChildSelected = useMatch(`${urlPrefix}/*`);

  const hasPermissionToViewItem = useHasPermission(
    OrderManagementPermissions.VIEW_ORDER_FULFILLMENT_ANALYTICS,
  );

  const isEnabledByTeamId = ANALYTICS_TEAM_IDS.includes(team._id.toString());
  const isEnabledByLocalStorage = isAnalyticsEnabledViaLocalStorage();

  if (
    (!isEnabledByTeamId && !isEnabledByLocalStorage) ||
    !hasPermissionToViewItem
  ) {
    return null;
  }

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.analyticsOrderFulfillmentHref }}
      anyChildSelected={!!anyChildSelected}
      FilledIcon={BarChart10FilledIcon}
      friendlyName="Analytics"
      id="analytics"
      UnfilledIcon={BarChart10Icon}
    >
      <RedoSecondaryNavItem
        action={{
          type: "link",
          href: routes.analyticsOrderFulfillmentHref,
        }}
        friendlyName="Order fulfillment"
        id="analytics-order-fulfillment"
      />
    </RedoSecondaryNavItem>
  );
});
